import InfoIcon from '@mui/icons-material/InfoOutlined'
import { InputAdornment } from '@mui/material'
import { ConsoleTooltip } from '@/components/ConsoleTooltip'

import { MULTI_SELECT_BOX_TEST_IDS } from '../MultiSelectBox.constants'

type MultiSelectEndAdornmentProps = {
  disabled?: boolean
  disabledInfo?: string
}

export const MultiSelectEndAdornment = ({
  disabled,
  disabledInfo
}: MultiSelectEndAdornmentProps) => {
  const shouldDisplayDisabledInfo = !!(disabled && disabledInfo)

  if (shouldDisplayDisabledInfo) {
    return (
      <InputAdornment
        position="end"
        sx={{
          position: 'absolute',
          top: '50%',
          right: 32
        }}
        data-testid={MULTI_SELECT_BOX_TEST_IDS.disabledInfo}
      >
        <ConsoleTooltip title={disabledInfo} placement="top" arrow distance={8}>
          <InfoIcon sx={{ opacity: 0.7 }} />
        </ConsoleTooltip>
      </InputAdornment>
    )
  }

  return null
}
